// extracted by mini-css-extract-plugin
module.exports = {"languageSwitcher":"languageSwitcher_languageSwitcher__Ee_ju","globeLang":"languageSwitcher_globeLang__AJrDa","footerLink":"languageSwitcher_footerLink__l1H5D"};